module.exports = __webpack_public_path__ + "img/windows.f1094851.svg";